import axios from 'axios'
import  messages  from '@/utils/ErrorMessages'
import { notify } from '@kyvg/vue3-notification'

export default {
    namespaced: true,

    state: () => ({
        surveys: [],
    }),
    getters:{
        getAll(state){
            return state.surveys
        },
        getById: (state) => (id) => {
            return state.surveys.find((item) => item.id === id ) || {}
        },
    },
    mutations: {
        save: (state, surveys) => state.surveys = surveys,

        add: (state, survey) => {
            state.surveys.push(survey)
        },
        update: (state, survey) => {
            const index = state.surveys.findIndex(s => s.id === survey.id);
            state.surveys.splice(index, 1, survey);
        },
        remove:(state, id) => {
            const index = state.surveys.findIndex(s => s.id === id);
            state.surveys.splice(index, 1);
        },
    },

    actions: {

        async fetchSurveys({commit}){
            await axios.get('/v1/satisfaction-survey')
            .then(response => {
                commit('save', response.data.data)
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            })
        },
        async fetchSurvey({commit}, id){
            return axios.get('/v1/satisfaction-survey/' + id)
            .then(response => {
                commit('add', response.data.data)
                return response.data.data
            }).catch(e => {
                return Promise.reject(e)
            })
        },

        async addSurvey({commit}, payload){
            return axios.post('/v1/satisfaction-survey', payload)
            .then(response => {
                commit('add', response.data.data)
                return response.data.data
            })
            .catch(e => {
                return Promise.reject(e)
            })
        },
        async editSurvey({commit}, {payload, id}){
            return axios.put('/v1/satisfaction-survey/' + id, payload)
            .then(response => {
                commit('update', response.data.data)
                return response.data.data
            }).catch(e => {
                const errorCode = e?.response?.data?.error || 'ServerError';
                return Promise.reject(errorCode)
            })
        },
        async removeSurvey({commit}, id){
            return axios.delete('v1/satisfaction-survey/' + id)
            .then(() => {
                commit('remove', id)
                return true
                //setTimeout(() => router.push({name: 'satisfaction.home'}), 1500)
            }).catch(e => {
                const errorCode = e?.response?.data?.error || 'ServerError';
                return Promise.reject(errorCode)
            })
        },
    },
};
